import React from "react";

export const NotFound: React.FC = () => {
    return (
        <>
            <h2>Not found</h2>
        </>
    )
}
